import { render, staticRenderFns } from "./StudentAchievementView.vue?vue&type=template&id=860eb07a&scoped=true"
import script from "./StudentAchievementView.vue?vue&type=script&lang=js"
export * from "./StudentAchievementView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "860eb07a",
  null
  
)

export default component.exports